
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play1",
      function () {
        return require("private-next-pages/play1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play1"])
      });
    }
  